// @flow

import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';
import { Component } from '../jsti/core';

export default class Swatch extends Component {
  #id: number = 0;
  #name: string = '';
  mainIdentifier: string;
  classes: Object = {
    active: [],
    disabled: [],
    neutral: []
  };

  stroke: ?HTMLElement;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.#id = parseInt(this.el.dataset.id);
    this.#name = this.el.dataset.name;

    this.mainIdentifier = this.el.dataset.mainIdentifier;
    this.classes.active = JSON.parse(this.el.dataset.activeClasses);
    this.classes.disabled = JSON.parse(this.el.dataset.disabledClasses);
    this.classes.neutral = JSON.parse(this.el.dataset.neutralClasses);

    this.stroke = this.el.getElementByRef('stroke');

    const clickHandler = this.handleClickEvents.bind(this);
    this.addEventListener(EventNames.CLICK, clickHandler);
    this.addListener(Notifications.CHANGE_PRODUCT, this.handleChangeProduct);
  }

  /**
   * Executes when the user switches from products
   */
  handleChangeProduct({ product, allProducts }: { product: Object, allProducts: Array<Object> }): void {
    this.setToNeutralState();

    if (product.identifiers[this.#name] === this.#id) {
      this.setToActiveState();
      return;
    }

    if (this.#name === this.mainIdentifier) return;

    if (!this.getAvailableProducts(product, allProducts).length) {
      this.setToDisabledState();
    }
  }

  /**
   * Executes when the user clicks on a swatch
   */
  handleClickEvents() {
    this.notify(Notifications.SELECT_PRODUCT, { id: this.#id, name: this.#name });
  }

  /**
   * Set the swatch to its neutral state
   */
  setToNeutralState(): void {
    this.el.removeAttribute('disabled');
    this.el.classList.remove(...this.classes.active);
    this.el.classList.remove(...this.classes.disabled);
    this.el.classList.add(...this.classes.neutral);

    if (this.stroke) {
      this.stroke.classList.add('hidden');
    }
  }

  /**
   * Set the swatch to its active state
   */
  setToActiveState(): void {
    this.el.classList.remove(...this.classes.neutral);
    this.el.classList.add(...this.classes.active);
  }

  /**
   * Set the swatch to its disabled state
   */
  setToDisabledState(): void {
    this.el.setAttribute('disabled', true);
    this.el.classList.remove(...this.classes.neutral);
    this.el.classList.add(...this.classes.disabled);

    if (this.stroke) {
      this.stroke.classList.remove('hidden');
    }
  }

  /**
   * Get all available products for the current swatch in combination with the current main identifier
   */
  getAvailableProducts(activeProduct: Object, allProducts: Array<Object>): Array<Object> {
    return allProducts.filter((item: Object) => {
      return item.identifiers[this.mainIdentifier] === activeProduct.identifiers[this.mainIdentifier] &&
        item.identifiers[this.#name] === this.#id;
    });
  }
}
